import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoaderLight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	style: {
		margin: "auto",
		background: "transparent",
		display: "block",
		shapeRendering: "auto"
	},
	width: "221px",
	height: "221px",
	viewBox: "0 0 100 100",
	preserveAspectRatio: "xMidYMid",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 50A38 38 0 0 0 88 50A38 42.6 0 0 1 12 50",
		fill: "#ededed",
		stroke: "none",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			type: "rotate",
			dur: "0.7633587786259541s",
			repeatCount: "indefinite",
			keyTimes: "0;1",
			values: "0 50 52.3;360 50 52.3"
		})
	})
});
export default SvgLoaderLight;
